var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMatchShowcaseIcon = function SvgMatchShowcaseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243.741,
    height: 92.222,
    viewBox: "0 0 243.741 92.222",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2001",
    "data-name": "Ret\\xE2ngulo 2001",
    width: 243.741,
    height: 92.222,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5913",
    "data-name": "Grupo 5913",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5913-2",
    "data-name": "Grupo 5913",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8541",
    "data-name": "Caminho 8541",
    d: "M243.741,48.336A43.886,43.886,0,1,1,199.855,4.45h0a43.683,43.683,0,0,1,43.885,43.48c0,.135,0,.271,0,.406",
    fill: "#edddd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8542",
    "data-name": "Caminho 8542",
    d: "M199.853,92.221a43.649,43.649,0,0,1-24.785-7.664c.006-2.8.008-8.367-.043-14.223v-.312c.113-.248,3.017-1.09,7.5-1.9A128.365,128.365,0,0,1,200.8,66.241c.592-.02,1.213-.032,1.846-.032a53.219,53.219,0,0,1,16.715,2.629,47.861,47.861,0,0,1,14.262,7.539,43.778,43.778,0,0,1-33.77,15.844",
    fill: "#fd9476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8543",
    "data-name": "Caminho 8543",
    d: "M182.7,88.741h0a44.193,44.193,0,0,1-16.789-12.588c-.057-.068-.111-.139-.168-.205s-.1-.129-.152-.191a38.026,38.026,0,0,1,9.439-5.733,9.356,9.356,0,0,1,.94-.336h.011L182.7,88.743Z",
    fill: "#fd9476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8544",
    "data-name": "Caminho 8544",
    d: "M202.473,27.837s15.085.72,15.938-13.746c.91-15.4-13.34-16.877-19.391-10.651S194.089,16,194.089,16s-4.218-3.8-8.819.867c-3.377,3.433-1.638,9.033-1.638,9.033s-7.781-.3-7.055,6.493a15.167,15.167,0,0,0,5.583,10.243Z",
    fill: "#fd9476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8545",
    "data-name": "Caminho 8545",
    d: "M188.683,54.473,190.251,70.5s3.341,4.325,12.792,4.169c7.041-.116,9.34-1.935,9.34-1.935l-1.77-8.021-1.731-7.823-17.3-2.068Z",
    fill: "#ffbeb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8546",
    "data-name": "Caminho 8546",
    d: "M191.586,54.823a5.319,5.319,0,0,0,.617,1.5c4.371,7.656,14.345,8.423,18.415,8.39l-1.735-7.823Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8547",
    "data-name": "Caminho 8547",
    d: "M208.886,20.006s10.374,19.27,8.15,30.764-12.6,10.564-18.9,8.9a20.337,20.337,0,0,1-9.45-5.189,8.661,8.661,0,0,1-9.823-2.6c-4.263-5-2.409-11.3.741-12.972s7.227.37,7.227.37l-3.52-5.559s10.375-30.573,25.575-13.709",
    fill: "#ffbeb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8548",
    "data-name": "Caminho 8548",
    d: "M187.015,48.054a.693.693,0,0,1-.35-.094l-6.35-3.689a.7.7,0,0,1,.672-1.228l.028.016,6.357,3.689a.7.7,0,0,1-.353,1.308"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8549",
    "data-name": "Caminho 8549",
    d: "M181.83,48.61a.7.7,0,0,1-.325-1.322l3.234-1.69a.7.7,0,0,1,.649,1.243l-3.239,1.689a.691.691,0,0,1-.324.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8550",
    "data-name": "Caminho 8550",
    d: "M211.693,27.562a.7.7,0,0,1-.391-.119,3.127,3.127,0,0,0-3.5-.013.7.7,0,1,1-.826-1.131,4.53,4.53,0,0,1,5.11-.015.7.7,0,0,1-.392,1.282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8551",
    "data-name": "Caminho 8551",
    d: "M209.541,45.808a.771.771,0,0,1-.135-.013.7.7,0,0,1-.554-.82h0a12.066,12.066,0,0,0-2.346-9.914.7.7,0,0,1,1.036-.943,13.313,13.313,0,0,1,2.685,11.123.7.7,0,0,1-.687.568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8552",
    "data-name": "Caminho 8552",
    d: "M211.7,37.023a.7.7,0,0,1-.7-.671l-.163-3.824a.7.7,0,1,1,1.4-.06l.163,3.826a.7.7,0,0,1-.67.729H211.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8553",
    "data-name": "Caminho 8553",
    d: "M201.18,38.03a.7.7,0,0,1-.7-.671l-.164-3.824a.7.7,0,0,1,.667-.732h0a.7.7,0,0,1,.73.669v0l.164,3.826a.7.7,0,0,1-.67.729h-.031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8554",
    "data-name": "Caminho 8554",
    d: "M211.012,24.371a6.8,6.8,0,0,0-6.057-2.688,8.678,8.678,0,0,0-6.06,3.408s2.412,6.561-2.675,10.67-9.4,3.519-9.4,3.519l-4.081-1.02-3.456-5.48L189.5,19.371l14-9.24,8.193,6.1Z",
    fill: "#fd9476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8555",
    "data-name": "Caminho 8555",
    d: "M206.21,49.916a5.879,5.879,0,0,1-5.244-2.874.7.7,0,0,1,1.2-.716A4.745,4.745,0,0,0,207,48.455a.7.7,0,1,1,.266,1.376,5.988,5.988,0,0,1-1.061.085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8556",
    "data-name": "Caminho 8556",
    d: "M215.923,42.8a7.04,7.04,0,1,1,6.828-7.246c0,.07,0,.139,0,.209a6.944,6.944,0,0,1-6.831,7.037m0-12.672a5.639,5.639,0,1,0,5.425,5.845c0-.07,0-.14,0-.21a5.541,5.541,0,0,0-5.429-5.633",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8557",
    "data-name": "Caminho 8557",
    d: "M199.7,44.364a7.037,7.037,0,1,1,7.037-7.037,7.038,7.038,0,0,1-7.037,7.037m0-12.672a5.635,5.635,0,1,0,5.635,5.635,5.635,5.635,0,0,0-5.635-5.635",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8558",
    "data-name": "Caminho 8558",
    d: "M205.353,37.295a.7.7,0,0,1-.056-1.4l4.954-.4a.7.7,0,0,1,.114,1.4l-4.954.4h-.057",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8559",
    "data-name": "Caminho 8559",
    d: "M182.747,38.962a.7.7,0,0,1-.51-1.181c3.768-4,11.134-.3,11.445-.143a.7.7,0,1,1-.638,1.247c-.067-.034-6.739-3.382-9.787-.143a.7.7,0,0,1-.51.22",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8560",
    "data-name": "Caminho 8560",
    d: "M203.233,74.813a24.713,24.713,0,0,1-14.9-4.9.7.7,0,0,1,.83-1.131c12.373,9.091,25.727,2.01,25.86,1.935a.7.7,0,1,1,.671,1.23,28.79,28.79,0,0,1-12.461,2.866",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8561",
    "data-name": "Caminho 8561",
    d: "M196.22,29.837a.7.7,0,0,1-.594-1.072l0,0a5.038,5.038,0,0,1,6.213-2.272.7.7,0,0,1-.541,1.294,3.654,3.654,0,0,0-4.486,1.727.7.7,0,0,1-.594.328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8562",
    "data-name": "Caminho 8562",
    d: "M166.772,48.336A43.886,43.886,0,1,1,122.886,4.45h0a43.683,43.683,0,0,1,43.885,43.48c0,.135,0,.271,0,.406",
    fill: "#edddd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8563",
    "data-name": "Caminho 8563",
    d: "M136.441,89.53c-1.369,0-2.188-8.207-2.2-8.289l-22.49,4.342a46.063,46.063,0,0,1-8.157-3.948,29.464,29.464,0,0,1-6.078-4.83,14.371,14.371,0,0,1-3.75-6.644c-1.066-4.8,1.151-9.891,6.59-15.123a52.517,52.517,0,0,1-.635-5.594,58.148,58.148,0,0,1,.535-12.787,32.991,32.991,0,0,1,5.36-13.992,23.445,23.445,0,0,1,13.838-9.213,24.054,24.054,0,0,1,5.789-.762,16.444,16.444,0,0,1,11.869,4.819,28.359,28.359,0,0,1,6.439,10.6,57.7,57.7,0,0,1,3.176,15.418,37.954,37.954,0,0,1,6.66,2.149,42.5,42.5,0,0,1,6.356,3.3,36.418,36.418,0,0,1,6.623,5.328,43.079,43.079,0,0,1-1.069,5.313,43.738,43.738,0,0,1-9.347,17.578c-1.764-.092-4.322-.408-6.8-.713l-.141-.017-.068-.008c-2.973-.369-6.047-.75-7.816-.75-1.012,0-1.518.121-1.545.373C138.523,85,137.466,89.53,136.441,89.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8564",
    "data-name": "Caminho 8564",
    d: "M92.771,80.243a43.722,43.722,0,0,0,30.111,11.979v0l0,0a43.684,43.684,0,0,0,4.713-.247l.077-.01q1.11-.12,2.208-.3c.091-.015.18-.033.27-.048.669-.112,1.334-.236,1.994-.378.115-.025.228-.053.343-.079.632-.141,1.262-.294,1.886-.463.131-.035.26-.074.39-.111q.9-.252,1.794-.543c.146-.047.291-.1.436-.147q.855-.29,1.7-.613l.488-.193q.8-.319,1.585-.671c.181-.081.362-.161.542-.245.5-.229.987-.47,1.475-.718.2-.1.393-.2.587-.3.465-.245.923-.5,1.379-.765.2-.117.409-.231.61-.351.449-.267.89-.549,1.329-.833.194-.125.392-.246.584-.374.5-.332.982-.678,1.465-1.031.122-.088.248-.171.368-.261q.9-.671,1.764-1.388c.117-.1.229-.2.345-.3.46-.389.917-.785,1.362-1.195.142-.13.279-.267.419-.4.421-.4.839-.8,1.245-1.217.116-.119.229-.241.344-.361.437-.457.867-.922,1.285-1.4.032-.036.064-.073.1-.11a47.057,47.057,0,0,0-12-5.308h-.031l-.031-.006a.384.384,0,0,1-.082-.016,58.089,58.089,0,0,0-15.95-2.14,69.517,69.517,0,0,0-26.5,5.287,17.187,17.187,0,0,0-8.595,5.258",
    fill: "#fd9476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8565",
    "data-name": "Caminho 8565",
    d: "M114.723,61.165v.375l.316,7.084.226,5.556s-.475,1.291,5.991.872c8.667-.594,11.461-4.317,11.461-4.317l.369-13.022-2.627.5Z",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8566",
    "data-name": "Caminho 8566",
    d: "M114.725,61.541l.316,7.084c4.211-.511,11.876-2.335,14.973-8.959a5.442,5.442,0,0,0,.447-1.425l-15.709,3.193Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8567",
    "data-name": "Caminho 8567",
    d: "M111.977,27.633s-8.06,18.446-5.156,28.814,12.345,8.732,18,6.729a18.692,18.692,0,0,0,8.27-5.468,7.966,7.966,0,0,0,8.808-3.118c3.529-4.912,1.356-10.543-1.657-11.843s-6.6.885-6.6.885l2.809-5.361s-11.812-27.238-24.469-10.638",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8568",
    "data-name": "Caminho 8568",
    d: "M114.481,24.9s.215,8.513,10.088,12.973,15.67,4.877,15.67,4.877l-.641-12.8L127.239,16.528l-11.048,3.521Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8569",
    "data-name": "Caminho 8569",
    d: "M132.974,40.807l.037,5.589,4.971-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8570",
    "data-name": "Caminho 8570",
    d: "M119.4,75.817a31.8,31.8,0,0,1-7.059-.758.663.663,0,0,1,.318-1.288c.117.031,11.809,2.819,19.838-3.033a.663.663,0,0,1,.78,1.073c-4.4,3.211-9.707,4.005-13.877,4.005",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8571",
    "data-name": "Caminho 8571",
    d: "M109.685,34.371a.663.663,0,0,1-.2-1.3l3.676-1.149a.664.664,0,1,1,.4,1.266l-3.676,1.149a.648.648,0,0,1-.2.031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8572",
    "data-name": "Caminho 8572",
    d: "M134.019,52.246a.663.663,0,0,1-.448-1.152l5.686-5.232a.664.664,0,1,1,.9.976l-5.689,5.233a.654.654,0,0,1-.448.175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8573",
    "data-name": "Caminho 8573",
    d: "M139.78,51.558a.68.68,0,0,1-.267-.056l-3.394-1.49a.664.664,0,0,1,.5-1.229l.031.014,3.394,1.49a.664.664,0,0,1-.268,1.271"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8574",
    "data-name": "Caminho 8574",
    d: "M110.822,43.675a.661.661,0,0,1-.665-.657.688.688,0,0,1,.015-.143l.678-3.265-1.333-1.535a.663.663,0,0,1,.963-.911.505.505,0,0,1,.037.042l1.548,1.784a.655.655,0,0,1,.149.569l-.744,3.587a.663.663,0,0,1-.649.528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8575",
    "data-name": "Caminho 8575",
    d: "M121.944,44.24a.661.661,0,0,1-.665-.657.687.687,0,0,1,.015-.143l.678-3.265-1.333-1.536a.663.663,0,1,1,.963-.911.5.5,0,0,1,.037.042l1.548,1.784a.655.655,0,0,1,.149.569l-.744,3.587a.663.663,0,0,1-.649.528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8576",
    "data-name": "Caminho 8576",
    d: "M113.023,51.775a.665.665,0,0,1-.649-.527c-1.234-5.9,1.621-8.869,1.745-8.993a.663.663,0,0,1,.945.931c-.11.114-2.469,2.637-1.39,7.789a.664.664,0,0,1-.513.785.632.632,0,0,1-.137.015"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8577",
    "data-name": "Caminho 8577",
    d: "M119.017,57.449c-.4,0-1.336-.183-3.3-2.359a.981.981,0,0,1-.22-.914,1.026,1.026,0,0,1,.7-.7c4.735-1.416,5.376-.931,5.652-.724a1.251,1.251,0,0,1,.329,1.487c-.36,1.209-1.865,3.124-3.043,3.2-.033,0-.072.005-.118.005M117.073,54.6a5.6,5.6,0,0,0,1.973,1.516,2.7,2.7,0,0,0,1.1-.95,4.113,4.113,0,0,0,.775-1.369,19.628,19.628,0,0,0-3.851.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8578",
    "data-name": "Caminho 8578",
    d: "M87.772,48.336A43.886,43.886,0,1,1,43.886,4.45h0A43.683,43.683,0,0,1,87.772,47.93c0,.135,0,.271,0,.406",
    fill: "#edddd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8579",
    "data-name": "Caminho 8579",
    d: "M43.886,92.219A43.794,43.794,0,0,1,14.4,80.84a59.888,59.888,0,0,1,13.955-6.951,32.225,32.225,0,0,1,5.7-1.443v-.008c-.043-.33-.412-3.258,0-4.067A4.878,4.878,0,0,1,36.2,66.93c.251-.1.412-.166.416-.168s.05-.01.132-.023c.313-.053,1.145-.192,2.285-.368,2.184-.349,7.733-1.2,12.059-1.519,1.1-.092,2.092-.139,2.953-.139h.27a5.728,5.728,0,0,1,2.138.3c.495.225,1.067,1.736,1.071,1.752h.013a63.59,63.59,0,0,1,8.434-.5,81.865,81.865,0,0,1,9.047.5c1,.113,3.771.477,8.029,1.4a43.868,43.868,0,0,1-39.16,24.055Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8580",
    "data-name": "Caminho 8580",
    d: "M33.848,40.279S23.474,36.948,23.413,44.75c-.065,9.039,10.645,8.123,10.645,8.123Z",
    fill: "#c7715c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8581",
    "data-name": "Caminho 8581",
    d: "M53.829,59.89l1.062,10.475A22.178,22.178,0,0,1,46,73.479c-6.818.754-9.5-3.082-9.5-3.082L35.4,58.1Z",
    fill: "#c7715c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8582",
    "data-name": "Caminho 8582",
    d: "M53.829,59.874s-2.481,8.79-10.341,8.354c-6.336-.351-8.949-9.046-8.949-9.046Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8583",
    "data-name": "Caminho 8583",
    d: "M29.875,32s-2.588,19.6,3.7,27.58c6.742,8.561,15.973,4.956,19.273,1.893A16.094,16.094,0,0,0,57.8,52.136s6.708.7,8.4-4.877c1.78-5.857-2.745-10.026-6.064-9.988s-3.648.675-3.648.675l.4-6.115S34.786,11.443,29.865,32",
    fill: "#c7715c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8584",
    "data-name": "Caminho 8584",
    d: "M47.924,42.209a.635.635,0,0,1-.635-.615l-.112-3.245a.635.635,0,0,1,.612-.657h0a.621.621,0,0,1,.656.582c0,.011,0,.021,0,.032l.112,3.245a.635.635,0,0,1-.612.657h-.024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8585",
    "data-name": "Caminho 8585",
    d: "M35.509,42.688a.635.635,0,0,1-.635-.615l-.112-3.245a.636.636,0,1,1,1.272-.043l.112,3.245a.636.636,0,0,1-.613.658h-.024Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8586",
    "data-name": "Caminho 8586",
    d: "M42.01,50.713a.637.637,0,0,1-.61-.456,18.1,18.1,0,0,1-.188-9.485.637.637,0,0,1,1.221.363,17.111,17.111,0,0,0,.188,8.761.638.638,0,0,1-.43.791.62.62,0,0,1-.181.027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8587",
    "data-name": "Caminho 8587",
    d: "M33.3,36.06a.637.637,0,0,1-.461-1.076,6.514,6.514,0,0,1,3.727-1.558.637.637,0,0,1,.152,1.265l-.052,0a5.3,5.3,0,0,0-2.909,1.168.634.634,0,0,1-.461.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8588",
    "data-name": "Caminho 8588",
    d: "M49.256,35.8a.634.634,0,0,1-.321-.087,5.3,5.3,0,0,0-3.115-.317.637.637,0,0,1-.255-1.248,6.5,6.5,0,0,1,4.012.465.637.637,0,0,1-.321,1.187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8589",
    "data-name": "Caminho 8589",
    d: "M58.015,37.837s-1.519,6.109-2.307,5.938-.369-9.619,1.824-10.2.483,4.265.483,4.265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8590",
    "data-name": "Caminho 8590",
    d: "M42.965,56.249a.636.636,0,0,1-.027-1.272A5.36,5.36,0,0,0,47.4,52.14a.637.637,0,0,1,1.16.527c-1.542,3.39-5.4,3.575-5.565,3.58h-.025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8591",
    "data-name": "Caminho 8591",
    d: "M56.995,37.049s-6.685-.267-11.3-3.525a17.191,17.191,0,0,1-5.54-6.854s-2.879-.242-6.852,2.448-3.953,10.46-3.953,10.46-8.118-12.813-4.728-17.62,9.438-1.2,9.438-1.2-1.416-8.547,10.623-5.742a20.938,20.938,0,0,1,15.2,12.951s4.044-.533,4.712,3.206a17.2,17.2,0,0,1-.7,7.63,4.406,4.406,0,0,0-4.51-.475l-2.671,1.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8592",
    "data-name": "Caminho 8592",
    d: "M36.618,66.769s1.581,3.194,7.52,3.707,10.2-5.573,10.2-5.573l3.449,6.33-8.53,5.208-14.3-1.2v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8593",
    "data-name": "Caminho 8593",
    d: "M42.521,77.094a11.734,11.734,0,0,1-8.981-4.283.637.637,0,0,1,1.029-.75A10.314,10.314,0,0,0,46.03,75.272a.637.637,0,0,1,.37,1.218,13.286,13.286,0,0,1-3.879.6",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMatchShowcaseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/match-showcase-icon.c43a0f4f.svg";
export { ForwardRef as ReactComponent };